import { PublicLotsPage } from '@web-kc/pages/tenders';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export default PublicLotsPage;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale = 'ru',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? defaultLocale, [
        'common',
        'tenders',
        'cabinet',
      ])),
    },
  };
};
